import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/mocks/articles";

interface FeaturedSectionProps {
  items: Article[];
}

export default function FeaturedSection({ items }: FeaturedSectionProps) {
  return (
    <section aria-labelledby="featured-heading" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="max-w-2xl">
          <h2 id="featured-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            编辑精选：值得回看的几篇
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            从存档里挑出的长线话题复盘，适合想一次看懂某个话题走向的读者。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <ArticleCard key={item.id} article={item} />
          ))}
        </div>
      </div>
    </section>
  );
}